import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-form-configuration-tab-select',
    templateUrl: './form-configuration-tab-select.component.html',
    styleUrls: ['./form-configuration-tab-select.component.scss'],
    standalone: false
})
export class FormConfigurationTabSelectComponent implements OnInit {

  
  options:BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  tabs = new UntypedFormControl(null, [
    Validators.required
  ]);
  
  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>) { }

  ngOnInit(): void {
    this.options.next(this.data);
  }

  ngAfterContentInit(): void {
    
  }

  salvar(){
    
    this.dialogRef.close(this.tabs.value)
  }
}
